import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../components/modal/modal.component';
import {StyledFooter} from '../../../components/pane/pane.style';
import {StyledModalContent} from '../../../components/modal/modal.style';
import {StyledRedButton, StyledWiteButton} from '../../../components/button/button.style';
import {StyledTextarea} from '../../../components/form/input/textarea.style';
import {disableSwipeToClose} from '../../../utils/tools/modals';


type AutoContractRejectModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onReject: (reason: string) => void;
};

const AutoContractRejectModal: React.FC<AutoContractRejectModalProps> = (props) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [reason, setReason] = useState<string>('');

    useEffect(() => {
        setIsOpen(props.isOpen);
        if (!props.isOpen) {
            setReason('');
        }
    }, [props.isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            canDismiss={disableSwipeToClose}
            onDidDismiss={() => props.onClose()}>
            <StyledModalContent>
                <h1 className="title">{t('contractPage.autoContract.reject.title')}</h1>
                <div className="content">
                    <p>{t('contractPage.autoContract.reject.info')}</p>
                    <StyledTextarea
                        className="full-width"
                        placeholder={t('contractPage.autoContract.reject.reasonPlaceholder')}
                        value={reason}
                        onChange={(e: any) => setReason(e.target.value)}
                    />
                </div>
                <StyledFooter className="modal footer no-shadow">
                    <StyledWiteButton onClick={() => props.onClose()}>
                        {t('common.cancel')}
                    </StyledWiteButton>
                    <StyledRedButton
                        disabled={!reason.trim()}
                        onClick={() => props.onReject(reason.trim())}>
                        {t('contractPage.autoContract.reject.button')}
                    </StyledRedButton>
                </StyledFooter>
            </StyledModalContent>
        </Modal>
    );
};

export default AutoContractRejectModal;
